import { render, staticRenderFns } from "./DiscordAssociationModal.vue?vue&type=template&id=2b4bc7c1&scoped=true"
import script from "./DiscordAssociationModal.vue?vue&type=script&lang=js"
export * from "./DiscordAssociationModal.vue?vue&type=script&lang=js"
import style0 from "./DiscordAssociationModal.vue?vue&type=style&index=0&id=2b4bc7c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4bc7c1",
  null
  
)

export default component.exports